(function () {
  if (!document.body.classList.contains("ss-all-products-page")) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var CHIPS = [
    { key: "all", label: "All Formulas" },
    { key: "flagship", label: "ADDY XR" },
    { key: "energy", label: "Energy" },
    { key: "mushroom", label: "Mushroom" },
    { key: "her", label: "For Her" },
  ];

  function getProductHandle(card) {
    var link = card.querySelector("a[href*='/products/']");
    if (!link) return "";
    var href = link.getAttribute("href") || "";
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  }

  function getCategory(handle) {
    if (!handle) return "other";
    if (handle.indexOf("addy-xr") >= 0) return "flagship";
    if (handle.indexOf("mushroom") >= 0 || handle.indexOf("addy-focus-organic") >= 0) return "mushroom";
    if (handle.indexOf("energy-for-her") >= 0 || handle.indexOf("energy-booster-for-women") >= 0) return "her";
    if (handle.indexOf("addy-energy") >= 0 || handle.indexOf("addy-plus") >= 0) return "energy";
    return "other";
  }

  function getProductCards() {
    return Array.prototype.slice.call(document.querySelectorAll(".product-grid__item"));
  }

  function getCollectionTitle() {
    var heading = document.querySelector("#MainContent .shopify-section.section-wrapper h1");
    if (heading) return heading.textContent.trim();
    return document.title.replace(/\s*[–-]\s*Shop-Satisfied.*$/i, "").trim() || "All Products";
  }

  function splitTitle(title) {
    var parts = title.split(/\s+/);
    if (parts.length <= 1) return { main: title, accent: "" };
    if (parts.length === 2) return { main: parts[0], accent: parts[1] };
    return { main: parts.slice(0, -1).join(" "), accent: parts[parts.length - 1] };
  }

  function ensureHero() {
    if (document.querySelector(".ss-all-products")) return document.querySelector(".ss-all-products");

    var main = document.querySelector("#MainContent");
    if (!main) return null;

    var headingSection = main.querySelector(".shopify-section.section-wrapper");
    var title = getCollectionTitle();
    var split = splitTitle(title);
    var count = getProductCards().length;

    var hero = document.createElement("section");
    hero.className = "ss-all-products section-wrapper";
    hero.id = "ss-all-products-page";
    hero.innerHTML =
      '<div class="ss-all-products__hero ss-reveal">' +
      '<div class="ss-all-products__hero-inner">' +
      '<p class="ss-all-products__eyebrow">Shop</p>' +
      '<h1 class="ss-all-products__title"></h1>' +
      '<p class="ss-all-products__subhead">Explore our full lineup of science-backed energy and focus supplements — made in the USA with a 60-day guarantee.</p>' +
      (count > 0
        ? '<p class="ss-all-products__count" aria-live="polite">' +
          count +
          " " +
          (count === 1 ? "formula" : "formulas") +
          " available</p>"
        : "") +
      "</div></div>" +
      '<div class="ss-all-products__trust ss-reveal ss-reveal-delay-1" role="list" aria-label="Store highlights">' +
      '<span class="ss-all-products__trust-item" role="listitem"><strong>★ 4.83</strong> Customer Rating</span>' +
      '<span class="ss-all-products__trust-item" role="listitem"><strong>Free Shipping</strong> on All Orders</span>' +
      '<span class="ss-all-products__trust-item" role="listitem"><strong>60-Day</strong> Money-Back Guarantee</span>' +
      '<span class="ss-all-products__trust-item" role="listitem"><strong>Made in the USA</strong></span>' +
      "</div>";

    var titleEl = hero.querySelector(".ss-all-products__title");
    titleEl.textContent = split.main;
    if (split.accent) {
      var accent = document.createElement("span");
      accent.textContent = split.accent;
      titleEl.appendChild(accent);
    }

    main.insertBefore(hero, main.firstChild);

    main.querySelectorAll(".shopify-section.section-wrapper").forEach(function (section) {
      if (section === hero || section.contains(hero)) return;
      if (section.querySelector("h1")) {
        section.setAttribute("hidden", "hidden");
        section.setAttribute("aria-hidden", "true");
      }
    });

    return hero;
  }

  function initFinder() {
    if (document.querySelector(".ss-ap-finder")) return;

    var collectionSection = document.querySelector(".product-grid-container");
    if (!collectionSection) return;

    var wrapper = document.createElement("div");
    wrapper.className = "ss-ap-finder ss-ap-reveal";
    wrapper.innerHTML =
      '<p class="ss-ap-finder__label">Find Your Formula</p>' +
      '<h2 class="ss-ap-finder__title">Shop by Goal</h2>' +
      '<div class="ss-ap-finder__chips" role="tablist" aria-label="Filter products by goal"></div>';

    var chipsEl = wrapper.querySelector(".ss-ap-finder__chips");
    CHIPS.forEach(function (chip) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ss-ap-chip" + (chip.key === "all" ? " is-active" : "");
      btn.textContent = chip.label;
      btn.setAttribute("role", "tab");
      btn.setAttribute("aria-selected", chip.key === "all" ? "true" : "false");
      btn.dataset.filter = chip.key;
      chipsEl.appendChild(btn);
    });

    collectionSection.parentElement.insertBefore(wrapper, collectionSection);

    chipsEl.addEventListener("click", function (event) {
      var chip = event.target.closest(".ss-ap-chip");
      if (!chip) return;
      var filter = chip.dataset.filter;
      chipsEl.querySelectorAll(".ss-ap-chip").forEach(function (el) {
        el.classList.toggle("is-active", el === chip);
        el.setAttribute("aria-selected", el === chip ? "true" : "false");
      });
      applyFilter(filter);
    });
  }

  function applyFilter(filterKey) {
    var cards = getProductCards();
    var visible = 0;

    cards.forEach(function (card) {
      var handle = getProductHandle(card);
      var category = getCategory(handle);
      var show = filterKey === "all" || category === filterKey;
      card.classList.toggle("is-filtered-out", !show);
      if (show) visible += 1;
    });

    var grid = document.querySelector(".product-grid");
    var empty = document.querySelector(".ss-ap-empty");
    if (visible === 0) {
      if (!empty && grid) {
        empty = document.createElement("li");
        empty.className = "ss-ap-empty";
        empty.textContent = "No products match this filter. Try another category.";
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  function initBottomCta() {
    if (document.querySelector(".ss-ap-bottom-cta")) return;

    var mainSection = document.querySelector(".product-grid-container");
    if (!mainSection) return;

    var cta = document.createElement("div");
    cta.className = "ss-ap-bottom-cta ss-ap-reveal";
    cta.innerHTML =
      "<p>Not sure which formula is right for you? Our team can help.</p>" +
      '<a href="/pages/contact">Contact Support →</a>';
    mainSection.appendChild(cta);
  }

  function initReveal(root) {
    var els = document.querySelectorAll(".ss-all-products .ss-reveal, .ss-ap-reveal");
    if (!els.length) return;

    if (reducedMotion) {
      els.forEach(function (el) {
        el.classList.add("ss-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("ss-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -24px 0px" }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  function hideLegacyHeadings() {
    var main = document.querySelector("#MainContent");
    if (!main) return;
    main.querySelectorAll(".shopify-section.section-wrapper").forEach(function (section) {
      if (section.classList.contains("ss-all-products") || section.querySelector(".ss-all-products")) return;
      if (section.querySelector("h1")) {
        section.setAttribute("hidden", "hidden");
        section.setAttribute("aria-hidden", "true");
      }
    });
  }

  function init() {
    ensureHero();
    hideLegacyHeadings();
    initFinder();
    initBottomCta();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
